import { render, staticRenderFns } from "./CustomAttributes.vue?vue&type=template&id=01e283f0&"
import script from "./CustomAttributes.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomAttributes.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports